import { z } from 'zod';
/**
 * Übersichten für den Dispatcher (Backoffice und Wirkia App): die Arbeitsliste der Aufträge, die Fahrer eines Tages mit Schicht und Aufträgen, der Fuhrpark eines Tages. Alles ist auf das beschränkt,
 * was zum Zuweisen nötig ist. Die Endpunkte verlangen das Recht `orders.plan`.
 */
export const DISPATCH_SCOPES = ['unassigned', 'today', 'tomorrow', 'upcoming', 'past', 'all'];
export const DISPATCH_SCOPE_LABELS = {
    unassigned: 'Zuweisen',
    today: 'Heute',
    tomorrow: 'Morgen',
    upcoming: 'Kommende',
    past: 'Vergangene',
    all: 'Alle',
};
export const dispatchBoardQuery = z.object({
    scope: z.enum(DISPATCH_SCOPES).default('unassigned'),
    q: z.string().trim().max(100).optional(),
});
export const dispatchDayQuery = z.object({ date: z.iso.date('Ungültiges Datum').optional() });
//# sourceMappingURL=dispatch-board.js.map